// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__128-_","buttons":"styles_buttons__2pstT"};